export default {
  buttons: {
    cancel: "Cancel ",
    dismiss: "dekat",
    add_waypoint: "Menambahkan tujuan "
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mil"
    }
  },
  search: {
    title: "Mencari ",
    placeholder: "Masukan lokasi",
    enter_location: "Masukan lokasi",
    help: {
      inactive: "Mencari "
    }
  },
  filters: {
    title: "Filter ",
    amenities: {
      title: "Pelayanan "
    },
    fuels: {
      title: "Jenis Bahan Bakar "
    }
  },
  directions: {
    title: "Perencana Rute ",
    placeholder: {
      destination: "Masukan lokasi",
      waypoint: "Masukan lokasi"
    },
    route: {
      title: "Pilihan Rute ",
      avoid_tolls: "Hindari jalan tol ",
      avoid_highways: "Hindari jalan sepeda motor",
      title_corridor: "Jarak tempuh dari rute ke pelayanan"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# hari} other {# hari-hari}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# menit}}\
`,
    button: "Mencari "
  },
  locations: {
    title: "lokasi ",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} dari  {place}"
  },
  info_window: {
    title: "Detail SPBU ",
    services: "Pelayanan ",
    nearby: "Dekat ke ",
    opening_hours: {
      title: "Jam Buka dan Tutup ",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Update terakhir ",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Perencana Rute "
  },
  fuels: {
    low_octane_gasoline: "Shell Regular",
    shell_regular_diesel: "Shell Diesel",
    super98: "Shell Super Extra",
    unleaded_super: "Shell Super"
  },
  amenities: {
    austrian_highway_sticker: "Stiker Jalan Bebas Hambatan Austria",
    bank_note_acceptor: "Mesin penyimpanan uang ",
    cafe: "Kafetaria ",
    carwash: "Pencucian Mobil",
    clubsmart_card: "Club smart card ",
    credit_card_american_express: "Kartu Kredit - American Express",
    credit_card_diners_club: "Kartu Kredit - Diners Club",
    credit_card_mastercard: "Kartu Kredit - Master Card",
    credit_card_visa: "Kartu Kredit - Visa",
    credit_card: "Kartu Kredit ",
    czech_highway_sticker: "Stiker Jalan Bebas Hambatan Czech ",
    food_offerings: "Penawaran Makanan ",
    full_service: "Pelayanan dengan attendant ",
    guarded_car_park: "Parkir yang dijaga",
    hgv_lane: "Untuk Truk ",
    high_speed_diesel_pump: "High speed diesel ",
    hot_food: "Makanan Panas",
    hungarian_highway_sticker: "Stiker Jalan Bebas Hambatan Hongaria",
    parking_lanes: "Tempat Parkier",
    partner_loyalty_accepted: "Partner Loyalti diterima ",
    pay_at_pump: "Membayar di Pompa ",
    restaurant: "Restoran ",
    self_service: "Pelayana Swalayan ",
    service_bay: "Tempat Pelayanan ",
    shop: "Toko ",
    shower: "Fasilitas Mandi ",
    slovak_highway_sticker: "Stiker Jalan Bebas Hambatan Slovakia ",
    snack_food: "Makanan Cepat/Snack ",
    standard_toilet: "Toilet",
    supermarket_fuel_discount: "Diskon Bahan Bakar",
    toilet: "Toilet",
    truck_parking: "Parkir truk ",
    truckport: "Hanya Truk ",
    twenty_four_hour: "24 Jam ",
    vacuum: "vacum ",
    vehicle_identity_system: "Sistem Identifikasi mobil "
  },
  settings: {
    title: "Setting ",
    tooltip: "Setting ",
    distance_units: {
      title: "Jarak",
      km: "km ",
      miles: "mil "
    },
    language: {
      title: "Bahasa "
    }
  }
}
